import React from 'react';
import { 
  HelpCircle, 
  Bell, 
  Sparkles, 
  Share2, 
  Clock, 
  Layout, 
  Star,
  Calendar 
} from 'lucide-react';

/**
 * Компонент с полезными советами по использованию таймера
 */
const TipsSidebar = () => {
  const tips = [
    {
      icon: Clock,
      title: 'Оптимальное использование',
      description: 'Создавайте несколько таймеров для разных задач и переключайтесь между ними.'
    },
    {
      icon: Bell,
      title: 'Уведомления',
      description: 'Разрешите браузерные уведомления, чтобы не пропустить важные события даже при неактивной вкладке.'
    },
    {
      icon: Layout,
      title: 'Внешний вид',
      description: 'Выберите "Российский флаг" или "День Победы" для патриотических событий.'
    },
    {
      icon: Calendar,
      title: 'Государственные праздники',
      description: 'Используйте предустановленные таймеры для российских праздников в разделе "Популярные события".'
    },
    {
      icon: Star,
      title: 'Избранное',
      description: 'Сохраняйте часто используемые таймеры для быстрого доступа в будущем.'
    },
    {
      icon: Share2,
      title: 'Поделиться',
      description: 'Скопируйте ссылку на страницу, чтобы поделиться таймером с друзьями и коллегами.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-indigo-500" />
        Полезные советы
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-indigo-500 mt-1 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-gray-50 dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded-lg">
        <div className="flex items-start space-x-3">
          <Sparkles className="w-5 h-5 text-amber-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-gray-900 dark:text-white mb-2">
              Внимание к деталям
            </h4>
            <p className="text-xs text-gray-600 dark:text-gray-400 mb-3">
              Большинство выдающихся достижений начинаются с правильной организации времени. Используйте таймеры для повышения продуктивности.
            </p>
            <button className="w-full py-1.5 text-xs bg-indigo-500 text-white rounded hover:bg-indigo-600 transition-colors">
              Подробнее о тайм-менеджменте
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TipsSidebar;